import { z } from "zod/v4";
export const generateTileInputSchema = z.object({
    kind: z.enum(["tile", "overlay"]).optional(),
    prompt: z.string().min(1),
    referenceTileIds: z.array(z.string()).optional(),
    referenceFilenames: z.array(z.string()).optional(),
    referenceOverlayIds: z.array(z.string()).optional(),
    referenceOverlayImageIds: z.array(z.string()).optional(),
    referenceImages: z.array(z.string()).optional(),
});
export const saveTileInputSchema = z.object({
    imageBase64: z.string().min(1),
    filename: z.string().min(1),
    tileSetId: z.string().optional(),
    taxonomyNodeId: z.string().min(1),
    tileSetLabel: z.string().min(1),
    existingTileSetId: z.string().optional(),
});
export const deleteTileInputSchema = z.object({
    tileSetId: z.string().optional(),
    filename: z.string().optional(),
    tileId: z.string().optional(),
});
